import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router';

import { PATH } from '../constants/path';

import { pageDisplay } from '../utils';

import ModalRoot from './modal/ModalRoot';
import BannerRoot from './banner/BannerRoot';
import HeadComponent from './HeadComponent';
import SkipLink from './rgaa/SkipLink';
import RouteAnnouncer from './rgaa/RouteAnnouncer';
import SessionTimeoutWarning from './rgaa/SessionTimeoutWarning';
import RouterComponent from './router/RouterComponent';
import ScrollToTopComponent from './ScrollToTopComponent';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.onRouteChanged = this.onRouteChanged.bind(this);
    }

    componentDidMount() {
        window.addEventListener('load', this.onRouteChanged);
    }

    componentWillUnmount() {
        window.removeEventListener('load', this.onRouteChanged);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        switch (window.location.pathname) {
            case PATH.HOME_PATH:
                pageDisplay('accueil');
                break;
            case PATH.ACCOUNT_JACKPOT_PATH:
                pageDisplay('cagnotte', 'mon_compte');
                break;
            case PATH.ACCOUNT_EBONS_PATH:
                pageDisplay('bon_achat', 'mon_compte');
                break;
            case PATH.ACCOUNT_PROFILE_PATH:
                pageDisplay('profil', 'mon_compte');
                break;
            case PATH.ACCOUNT_MESSAGES_PATH:
                pageDisplay('contact', 'mon_compte');
                break;
            case PATH.HOW_IT_WORK_PATH:
                pageDisplay('comment_ca_marche');
                break;
            case PATH.CASHBACK_ONLINE_MOST_POPULAR_PATH:
                pageDisplay('offres_en_ligne');
                break;
            case PATH.CASHBACK_EBON_MOST_POPULAR_PATH:
                pageDisplay('offres_en_bon_achat');
                break;
            case PATH.CASHBACK_OFFLINE_MOST_POPULAR_PATH:
                pageDisplay('offres_en_magasin');
                break;
            case PATH.EBON_CONFIRMATION_PATH:
                pageDisplay('validation_panier_confirmation', 'offres_en_bon_achat');
                break;
            case PATH.SCELLIUS_PATH:
                pageDisplay('validation_panier_paiement', 'offres_en_bon_achat');
                break;
            default:
                this.defaultEvents(window.location.pathname);
                break;
        }
    }

    defaultEvents(pathname) {
        if (pathname.startsWith(PATH.EBON_VALIDATION_PATH)) {
            pageDisplay('validation_panier_coordonnées', 'offres_en_bon_achat');
        }
    }

    render() {
        return (
            <div id="app">
                <SkipLink />
                <RouteAnnouncer />
                <HeadComponent />
                <Route component={RouterComponent} />
                <ModalRoot />
                <BannerRoot />
                <ScrollToTopComponent />
                <SessionTimeoutWarning />
            </div>
        );
    }

    static propTypes = {
        location: PropTypes.object.isRequired
    };
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App.js